const initialState = {
  currentPath: window.location.hash,
  currentPathId: '',
  navInternal: false,
  internalQueryParams: '',
};

const getters = {
  getCurrentPath: (state) => state.currentPath,
  getCurrentPathId: (state) => state.currentPathId,
  getNavInternal: (state) => state.navInternal,
  getInternalQueryParams: (state) => state.internalQueryParams,
};

const mutations = {
  setCurrentPath: (state, data) => {
    state.currentPath = data;
  },
  setCurrentPathId: (state, data) => {
    state.currentPathId = data;
  },
  setNavInternal: (state, data) => {
    state.navInternal = data;
  },
  setInternalQueryParams: (state, data) => {
    state.internalQueryParams = data;
  },
};

const actions = {
  setCurrentPath: ({ commit }, data) => {
    commit('setCurrentPath', data);
  },
  setCurrentPathId: ({ commit }, data) => {
    commit('setCurrentPathId', data);
  },
  setNavInternal: ({ commit }, data) => {
    commit('setNavInternal', data);
  },
  setInternalQueryParams: ({ commit }, data) => {
    commit('setInternalQueryParams', data);
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
